export enum OrderType {
  HOME_SALE = 1,
  PHARMACY_SALE,
  SALE_CALLCENTER,
  PRESCRIPTION,
  ECOMMERCE_SALE,
  HOME_SALE_TRANSFER,
  PHARMACY_SALE_TRANSFER,
  TRANSFER_DISPENSING,
  AGREEMENT,
  PRODUCT_CHANGE,
  SHIPPING_DISPENSING,
}
